import { render, staticRenderFns } from "./ModalAddComment.vue?vue&type=template&id=6a4eaf16"
import script from "./ModalAddComment.vue?vue&type=script&lang=js"
export * from "./ModalAddComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports